module.exports = __webpack_public_path__ + "static/media/bathrooms.a3cde355.svg";